import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenisInstance = null;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.resize();
    const h = document.querySelector("[data-testid=site-header]")?.offsetHeight ?? 80;
    lenisInstance.scrollTo(el, { offset: -(h + 24), force: true });
  } else el.scrollIntoView({ behavior: "smooth" });
};

export const SmoothScroll = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisInstance = lenis;
    let frame;
    const raf = (t) => {
      lenis.raf(t);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const t1 = setTimeout(() => scrollToId(id), 150);
      const t2 = setTimeout(() => {
        const top = document.getElementById(id)?.getBoundingClientRect().top;
        const h = document.querySelector("[data-testid=site-header]")?.offsetHeight ?? 80;
        if (top !== undefined && Math.abs(top - h - 24) > 40) scrollToId(id);
      }, 1400);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    }
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return children;
};
